import React from 'react'
import isBrowser from 'utils/isBrowser'
import { get } from 'lodash'

const sendTiming = (timings) => {
  Object.keys(timings).forEach((key) => {
    if (!window.ga) return
    if (!timings[key]) return

    window.ga('send', {
      hitType: 'timing',
      timingCategory: 'performance',
      timingVar: key,
      timingValue: timings[key],
    })
  })
}

class Performance extends React.PureComponent {
  static isSupported() {
    return isBrowser() && window.performance
  }

  constructor(props) {
    super(props)

    this.loadListener = null
    this.performance = null

    this.checkGa = this.checkGa.bind(this)

    if (Performance.isSupported()) {
      this.performance = window.performance
    }
  }

  componentDidMount() {
    if (Math.random() > 0.1) return
    if (!Performance.isSupported()) return
    if (this.loadListener) return

    this.loadListener = () => {
      setTimeout(() => {
        const timings = {
          'first-paint': Math.round(
            get(performance.getEntriesByName('first-paint'), [0, 'startTime'], 0) * 1e3,
          ),
          'first-contentful-paint': Math.round(
            get(performance.getEntriesByName('first-contentful-paint'), [0, 'startTime'], 0) * 1e3,
          ),
          ttfb: this.measureTiming('requestStart', 'responseStart'),
          'page-load-time': this.measureTiming('navigationStart', 'loadEventEnd'),
          'connect-time': this.measureTiming('requestStart', 'responseEnd'),
          'render-time': this.measureTiming('domLoading', 'domComplete'),
        }

        if (
          ['page-load-time', 'connect-time', 'render-time', 'ttfb']
            .map((key) => timings[key] === 0)
            .includes(true)
        )
          return

        // Timout loop to wait for google analytics to exist on window
        this.checkGa(timings)
      }, 0)
    }

    window.addEventListener('load', this.loadListener)
  }

  componentWillUnmount() {
    if (this.loadListener) {
      window.removeEventListener('load', this.loadListener)
    }
  }

  checkGa(timings) {
    if (!window.ga) {
      setTimeout(() => this.checkGa(timings), 200)
      return
    }

    sendTiming(timings)
  }

  measureTiming(from, to) {
    const fromValue = get(this.performance, ['timing', from])
    const toValue = get(this.performance, ['timing', to])

    if (fromValue && toValue) {
      return toValue - fromValue
    }

    return 0
  }

  render() {
    return null
  }
}

export default Performance
